const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function WindowsSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Licencias Windows', item: `${SITE_URL}/windows` },
    ],
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Licencias Windows Originales - Digital Licence Store',
    url: `${SITE_URL}/windows`,
    numberOfItems: 3,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'Licencia Windows 10 PRO Original',
          description: 'Licencia digital original Windows 10 Professional para 1 PC. Activación permanente de por vida.',
          url: `${SITE_URL}/windows`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '55385',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/windows`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '5',
            reviewCount: '287',
            bestRating: '5',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'Licencia Windows 11 PRO Original',
          description: 'Licencia digital original Windows 11 Professional para 1 PC. Activación permanente de por vida.',
          url: `${SITE_URL}/windows`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '65963',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/windows`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '5',
            reviewCount: '340',
            bestRating: '5',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Product',
          name: 'Licencia Windows 11 HOME Original',
          description: 'Licencia digital original Windows 11 Home para 1 PC. Activación permanente de por vida.',
          url: `${SITE_URL}/windows`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '79900',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/windows`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '5',
            reviewCount: '156',
            bestRating: '5',
          },
        },
      },
    ],
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Licencias Windows Originales Colombia - Digital Licence Store',
    description: 'Compra licencias originales de Windows 10 PRO y Windows 11 PRO/HOME al mejor precio en Colombia. Entrega inmediata por email.',
    url: `${SITE_URL}/windows`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
